import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header, Footer } from "@/components/Layout";
import { track } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import ImpressumPage from "@/pages/ImpressumPage";
import TeppichgroessePage from "@/pages/TeppichgroessePage";
import TeppichHubPage from "@/pages/TeppichHubPage";
import TeppichTabellePage from "@/pages/TeppichTabellePage";
import { TEPPICH_SEITEN } from "@/lib/teppichSeiten";
import BetonPage from "@/pages/BetonPage";
import BetonHubPage from "@/pages/BetonHubPage";
import { BETON_SEITEN } from "@/lib/betonSeiten";
import RechnerPage from "@/pages/RechnerPage";
import { RECHNER_SEITEN } from "@/lib/rechnerSeiten";
import SchuettgutPage from "@/pages/SchuettgutPage";
import SchuettgutHubPage from "@/pages/SchuettgutHubPage";
import { SCHUETTGUT_SEITEN } from "@/lib/schuettgutSeiten";
import PortionPage from "@/pages/PortionPage";
import PortionHubPage from "@/pages/PortionHubPage";
import { PORTION_SEITEN } from "@/lib/portionenSeiten";
import GetraenkePage from "@/pages/GetraenkePage";
import GetraenkeHubPage from "@/pages/GetraenkeHubPage";
import { GETRAENKE_SEITEN } from "@/lib/getraenkeSeiten";
import NotFoundPage from "@/pages/NotFoundPage";

function PageViewTracker() {
  useEffect(() => {
    track("page_view", { path: window.location.pathname });
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageViewTracker />
        <Header />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/teppichgroesse" element={<TeppichHubPage />} />
            <Route path="/teppich-groessentabelle" element={<TeppichTabellePage />} />
            {TEPPICH_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<TeppichgroessePage seite={s} />} />
            ))}
            <Route path="/betonrechner" element={<BetonHubPage />} />
            {BETON_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<BetonPage seite={s} />} />
            ))}
            {RECHNER_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<RechnerPage seite={s} />} />
            ))}
            <Route path="/kiesrechner" element={<SchuettgutHubPage />} />
            {SCHUETTGUT_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<SchuettgutPage seite={s} />} />
            ))}
            <Route path="/portionsrechner" element={<PortionHubPage />} />
            {PORTION_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<PortionPage seite={s} />} />
            ))}
            <Route path="/getraenkerechner" element={<GetraenkeHubPage />} />
            {GETRAENKE_SEITEN.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<GetraenkePage seite={s} />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
